import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'evento-item',
  templateUrl: './evento-item.component.html',
  styleUrls: ['./evento-item.component.scss']
})
export class EventoItemComponent implements OnInit {

  @Input("data") evento       = null;
  @Input("template") template = null;

  constructor() { }

  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
